var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 37 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: { cx: "18.9883", cy: "18.3022", r: "18", fill: "#73CDD3" },
      }),
      _c("path", {
        attrs: {
          d: "M27.4606 11.8121L27.163 11.5145L23.2663 7.61782L22.9687 7.32021C22.834 7.1855 22.6471 7.10791 22.4561 7.10791H11.2535C10.7957 7.10791 10.3027 7.46149 10.3027 8.23736V22.1621V28.5454V28.7241C10.3027 29.0472 10.6277 29.3622 11.0122 29.4614C11.0315 29.4664 11.05 29.4737 11.0701 29.4776C11.1303 29.4896 11.1917 29.4961 11.2535 29.4961H26.7222C26.7839 29.4961 26.8453 29.4896 26.9055 29.4776C26.9256 29.4737 26.9441 29.4664 26.9634 29.4614C27.3479 29.3622 27.6729 29.0472 27.6729 28.7241V28.5454V22.1621V12.5035C27.6729 12.2074 27.6374 11.9889 27.4606 11.8121ZM26.2968 11.74H23.0409V8.48401L26.2968 11.74ZM11.2535 28.7241C11.2261 28.7241 11.2014 28.7141 11.177 28.7052C11.1168 28.6766 11.0747 28.6164 11.0747 28.5454H26.9009C26.9009 28.6164 26.8588 28.6763 26.7986 28.7052C26.7743 28.7141 26.7496 28.7241 26.7222 28.7241H11.2535ZM11.0747 22.9341V8.23736C11.0747 8.15359 11.0875 7.87992 11.2535 7.87992H22.2912C22.2785 7.92855 22.2689 7.97873 22.2689 8.03085V12.512H26.75C26.8021 12.512 26.8519 12.5023 26.9005 12.4896C26.9005 12.4954 26.9009 12.4977 26.9009 12.5035V22.9341V28.5454H11.0747V22.9341Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M13.0032 14.438H16.4772C16.6903 14.438 16.8632 14.2651 16.8632 14.052C16.8632 13.8389 16.6903 13.666 16.4772 13.666H13.0032C12.7901 13.666 12.6172 13.8389 12.6172 14.052C12.6172 14.2651 12.7901 14.438 13.0032 14.438Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M13.0032 24.0884H16.4772C16.6903 24.0884 16.8632 23.9155 16.8632 23.7024C16.8632 23.4893 16.6903 23.3164 16.4772 23.3164H13.0032C12.7901 23.3164 12.6172 23.4893 12.6172 23.7024C12.6172 23.9155 12.7901 24.0884 13.0032 24.0884Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18.023 14.439C18.1234 14.439 18.2238 14.3965 18.2972 14.327C18.3667 14.2536 18.4092 14.1532 18.4092 14.0528C18.4092 13.9524 18.3667 13.852 18.2972 13.7786C18.1543 13.6357 17.8916 13.6357 17.7487 13.7786C17.6792 13.852 17.6367 13.9524 17.6367 14.0528C17.6367 14.1532 17.6792 14.2536 17.7487 14.327C17.8221 14.3965 17.9225 14.439 18.023 14.439Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18.023 24.0894C18.1234 24.0894 18.2238 24.0469 18.2972 23.9774C18.3667 23.904 18.4092 23.8036 18.4092 23.7032C18.4092 23.6028 18.3667 23.5023 18.2972 23.429C18.1543 23.2861 17.8916 23.2861 17.7487 23.429C17.6792 23.5023 17.6367 23.6028 17.6367 23.7032C17.6367 23.8036 17.6792 23.904 17.7487 23.9774C17.8221 24.0469 17.9225 24.0894 18.023 24.0894Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.5676 14.438H22.6557C22.8687 14.438 23.0417 14.2651 23.0417 14.052C23.0417 13.8389 22.8687 13.666 22.6557 13.666H19.5676C19.3546 13.666 19.1816 13.8389 19.1816 14.052C19.1816 14.2651 19.3546 14.438 19.5676 14.438Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.5676 24.0884H22.6557C22.8687 24.0884 23.0417 23.9155 23.0417 23.7024C23.0417 23.4893 22.8687 23.3164 22.6557 23.3164H19.5676C19.3546 23.3164 19.1816 23.4893 19.1816 23.7024C19.1816 23.9155 19.3546 24.0884 19.5676 24.0884Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.7292 19.572C12.6597 19.6454 12.6172 19.7458 12.6172 19.8463C12.6172 19.9467 12.6597 20.0471 12.7292 20.1205C12.8026 20.19 12.903 20.2325 13.0034 20.2325C13.1038 20.2325 13.2043 20.19 13.2777 20.1205C13.3472 20.0471 13.3897 19.9467 13.3897 19.8463C13.3897 19.742 13.3472 19.6454 13.2777 19.572C13.1347 19.4291 12.8721 19.4291 12.7292 19.572Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.6361 19.46H14.5481C14.335 19.46 14.1621 19.6329 14.1621 19.846C14.1621 20.059 14.335 20.232 14.5481 20.232H17.6361C17.8492 20.232 18.0221 20.059 18.0221 19.846C18.0221 19.6329 17.8492 19.46 17.6361 19.46Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.9705 13.666H24.1985C23.9854 13.666 23.8125 13.8389 23.8125 14.052C23.8125 14.2651 23.9854 14.438 24.1985 14.438H24.9705C25.1836 14.438 25.3565 14.2651 25.3565 14.052C25.3565 13.8389 25.1836 13.666 24.9705 13.666Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.9705 23.3164H24.1985C23.9854 23.3164 23.8125 23.4893 23.8125 23.7024C23.8125 23.9155 23.9854 24.0884 24.1985 24.0884H24.9705C25.1836 24.0884 25.3565 23.9155 25.3565 23.7024C25.3565 23.4893 25.1836 23.3164 24.9705 23.3164Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M13.0032 16.3721H21.4953C21.7083 16.3721 21.8813 16.1992 21.8813 15.9861C21.8813 15.773 21.7083 15.6001 21.4953 15.6001H13.0032C12.7901 15.6001 12.6172 15.773 12.6172 15.9861C12.6172 16.1992 12.7901 16.3721 13.0032 16.3721Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M13.0032 22.1626H21.4953C21.7083 22.1626 21.8813 21.9897 21.8813 21.7766C21.8813 21.5636 21.7083 21.3906 21.4953 21.3906H13.0032C12.7901 21.3906 12.6172 21.5636 12.6172 21.7766C12.6172 21.9897 12.7901 22.1626 13.0032 22.1626Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.4778 20.232H24.9699C25.183 20.232 25.3559 20.059 25.3559 19.846C25.3559 19.6329 25.183 19.46 24.9699 19.46H16.4778C16.2647 19.46 16.0918 19.6329 16.0918 19.846C16.0918 20.059 16.2647 20.232 16.4778 20.232Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.9716 15.6001H22.6555C22.4425 15.6001 22.2695 15.773 22.2695 15.9861C22.2695 16.1992 22.4425 16.3721 22.6555 16.3721H24.9716C25.1846 16.3721 25.3576 16.1992 25.3576 15.9861C25.3576 15.773 25.1846 15.6001 24.9716 15.6001Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.9716 21.3906H22.6555C22.4425 21.3906 22.2695 21.5636 22.2695 21.7766C22.2695 21.9897 22.4425 22.1626 22.6555 22.1626H24.9716C25.1846 22.1626 25.3576 21.9897 25.3576 21.7766C25.3576 21.5636 25.1846 21.3906 24.9716 21.3906Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M13.0032 18.3023H14.5472C14.7603 18.3023 14.9332 18.1294 14.9332 17.9163C14.9332 17.7032 14.7603 17.5303 14.5472 17.5303H13.0032C12.7901 17.5303 12.6172 17.7032 12.6172 17.9163C12.6172 18.1294 12.7901 18.3023 13.0032 18.3023Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.9531 17.5303H16.093C15.88 17.5303 15.707 17.7032 15.707 17.9163C15.707 18.1294 15.88 18.3023 16.093 18.3023H19.9531C20.1661 18.3023 20.3391 18.1294 20.3391 17.9163C20.3391 17.7032 20.1661 17.5303 19.9531 17.5303Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.9694 17.5303H21.4954C21.2823 17.5303 21.1094 17.7032 21.1094 17.9163C21.1094 18.1294 21.2823 18.3023 21.4954 18.3023H24.9694C25.1825 18.3023 25.3554 18.1294 25.3554 17.9163C25.3554 17.7032 25.1825 17.5303 24.9694 17.5303Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }